
import { Component } from 'react';
import FooterComponents from '../src/configurations/armodelviewer/components/FooterComponents' /*'{{CONFIGURATION_FOOTER_COMPONENTS}}'*/;
import OverlayComponents from '../src/configurations/armodelviewer/components/OverlayComponents'/*'{{CONFIGURATION_OVERLAY_COMPONENTS}}'*/;
import LoadingOverlay from './base/components/LoadingOverlay/LoadingOverlay';
import {BrowserRouter} from "react-router-dom";

// REACT_APP_BASENAME is injected at build time by scripts/deploy.js so the
// router prefix can differ between dev and live deployments without editing
// this file. Falls back to the dev prefix for a plain `npm start`/`npm run build`.
const BASENAME = process.env.REACT_APP_BASENAME !== undefined
    ? process.env.REACT_APP_BASENAME
    : "/1ee5270c/uploadform";

class App extends Component {
    
  state = {
  };

  

  render() {
    return (
        <div className="app" > {/*onContextMenu={this.handleContextMenu} onMouseDown={this.handleMouseDown} */}
            <LoadingOverlay />
            <div id="fullscreen-root" className="fullscreen-root">
                <BrowserRouter basename={BASENAME}>
                  <OverlayComponents className="overlay-components"/>
                
                </BrowserRouter>
            </div>
            <FooterComponents className="footer-components" />
        </div>
    );
  }
}



export default App;
